import React from "react";

const Title = props => <h1 className="tit left">{ props.children }</h1>;

export default Title;
